import React from "react";
import PropTypes from "prop-types";
import { Input } from "rbx";

import "./SocialSecurityInput.scss";

function SocialSecurityInput({ name, value, readOnly, onChange }) {
  const handleChange = e => {
    if (
      new RegExp(/\d/gi).test(e.target.value.substr(-1)) ||
      e.target.value === ""
    ) {
      onChange(e);
    }
  };
  return (
    <Input
      autocomplete="new"
      maxLength="4"
      name={name}
      readOnly={readOnly}
      type="text"
      value={value || ""}
      onChange={handleChange}
    />
  );
}

SocialSecurityInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.string,
  readOnly: PropTypes.bool
};

SocialSecurityInput.defaultProps = {
  value: ""
};

export default SocialSecurityInput;
